var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ext5_1",
    x: 0.726562,
    width: 40,
    height: 40,
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ext5_1_i",
    d: "M20.7266 8.75C14.9273 8.75 10.2266 13.4508 10.2266 19.25V29.795C10.2266 30.5992 10.8773 31.25 11.6816 31.25H16.2716C17.0758 31.25 17.7266 30.5992 17.7266 29.795V19.295C17.7266 17.6302 19.0583 16.2619 20.6945 16.25L20.6972 16.25C22.363 16.232 23.7266 17.5881 23.7266 19.25V29.795C23.7266 30.5992 24.3773 31.25 25.1816 31.25H29.7716C30.5758 31.25 31.2266 30.5992 31.2266 29.795V19.25C31.2266 13.4508 26.5258 8.75 20.7266 8.75ZM11.7266 25.25H16.2266V29.75H11.7266V25.25ZM25.2266 25.25H29.7266V29.75H25.2266V25.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnet);
export default __webpack_public_path__ + "static/media/Magnet.c9e41469.svg";
export { ForwardRef as ReactComponent };